/* ============================================================================
   The Sweet Tooth — Basket Builder cart guard
   Added 2026-08-06 after order #36317 (sympathy strawberries stamped
   "Basket Builder — Birthday" + "Happy Birthday" plaque).

   WHY THIS EXISTS
   Shopify cart attributes and the cart note live on the CART, not on the
   products. Shopify's own docs state that /cart/clear.js "does not remove
   cart attributes or the cart note." So once the Basket Builder stamps a
   cart with Occasion / Chocolate Plaque, that stamp survives the shopper
   emptying the cart, and rides along onto whatever they buy next.

   On a shared shop computer (staff taking phone orders back to back) the
   same browser cart is reused all day, so one abandoned Basket Builder
   session can mis-stamp every order that follows it.

   WHAT THIS DOES
   On every page load: if the cart carries Basket Builder stamps but holds
   no actual Basket Builder line item, the stamps are wiped.
   If a real basket IS in the cart, nothing is touched.
   ========================================================================= */
(function () {
  'use strict';

  var BB_ATTRS = [
    'Basket Builder',
    'Occasion',
    'Chocolate Plaque',
    'School',
    'Holiday Additions'
  ];

  // A line item belongs to the Basket Builder if it carries one of these
  // properties. Set by templates/page.basket-builder.liquid.
  function isBasketBuilderItem(item) {
    var p = (item && item.properties) || {};
    return !!(
      p['Basket Size'] ||
      p['Upgrade for'] ||
      p['Upgrade'] === 'Replaces the free basket plaque'
    );
  }

  function run() {
    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var attrs = cart.attributes || {};
        var items = cart.items || [];

        var hasAttrStamp = BB_ATTRS.some(function (k) {
          return attrs[k] !== undefined && attrs[k] !== null && attrs[k] !== '';
        });
        var hasNoteStamp =
          typeof cart.note === 'string' && cart.note.indexOf('Basket Builder') === 0;

        // Nothing to clean up.
        if (!hasAttrStamp && !hasNoteStamp) return;

        // A real Basket Builder order is in progress — leave it alone.
        if (items.some(isBasketBuilderItem)) return;

        // Stale stamp on a non-basket cart. Wipe only our keys; every other
        // attribute (BirdChime delivery dates, gift message, etc.) is kept.
        // 2026-10-25: send ONLY our keys. Shopify merges cart attributes, and re-sending every key could undo
        // a delivery choice saved a moment earlier by the cart's delivery step.
        var merged = {};
        BB_ATTRS.forEach(function (k) { merged[k] = ''; });

        var payload = { attributes: merged };
        if (hasNoteStamp) payload.note = '';

        console.log('[ST cart guard] Cleared stale Basket Builder stamps from cart.');

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(payload)
        });
      })
      .catch(function (err) {
        console.warn('[ST cart guard] skipped:', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
